<template>
  <two-sides-modal
    v-model="isDialogOpen"
    title="Detalle rebate"
    subtitle="Detalle Rebate"
    icon="mdi-list-box-outline"
    height="auto"
  >
    <table-toolbar
      class="mt-3"
      hide-delete
      hide-export
      :search="search"
      :message="`Trimestre: ${quarterText}`"
      @refresh="getRebateDetail()"
    />
    <rebate-detail-table
      :data="data"
      :search="search"
      :hide-headers="hideHeaders()"
      :items-per-page="5"
      hide-select
      hide-total
    />
    <div class="d-flex justify-end">
      <v-btn class="mt-4 green-button w-xs-100" @click="goToRebateDetail">
        Ir a detalle
      </v-btn>
    </div>
  </two-sides-modal>
</template>
<script>
  import TwoSidesModal from '@/components/modals/TwoSidesModal.vue';
  import RebateDetailTable from '@/components/tables/RebateDetailTable.vue';
  import TableToolbar from '@/components/tables/TableToolbar.vue';
  import Quarter from '@/core/models/quarter';

  export default {
    name: 'BonoRebateDetailModal',
    components: { TwoSidesModal, TableToolbar, RebateDetailTable },
    props: {
      value: {
        type: Boolean,
        default: true,
      },
      selectedRebate: {
        type: String,
        default: null,
      },
      data: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        search: '',
      };
    },
    computed: {
      quarterText() {
        const quarterParsed = Quarter.parse(this.selectedRebate);
        return Quarter.getPeriodLabel(quarterParsed.quarter);
      },
      isDialogOpen: {
        set(newVal) {
          this.$emit('input', newVal);
        },
        get() {
          return this.value;
        },
      },
    },
    methods: {
      goToRebateDetail() {
        this.isDialogOpen = false;
        this.$router.push({
          name: 'RebateDetail',
          params: { quarter: this.selectedRebate },
        });
      },
      getRebateDetail() {
        this.$emit('load', this.selectedRebate);
      },
      hideHeaders() {
        return ['FKIMGKG', 'NETWR1', 'REBATNC'];
      },
    },
  };
</script>
